import apiClient from 'whitelabel_api_requests';
import promotionConfig from './promotionConfig';

const apiClientWithConfig = () => {
    return apiClient(promotionConfig.apiClientConfig);
};

export default apiClientWithConfig;
